
import AP from '../config/api.config'
import PlatformLogo from '../components/common/PlatformLogo.vue'
import { fetchPublicConfig } from '../utils/publicConfig'
import { fetchCustomerService } from '../utils/customerService'

export default {
  name: 'SignUpPage',
  components: { PlatformLogo },
  data () {
    return {
      step: 1,
      phone: '',
      code: '',
      smsCode: '',
      clientSessionId: '',
      challengeId: '',
      grantToken: '',
      smsCountdown: 0,
      smsSending: false,
      authorizationCodeValidated: false,  // 授权码是否通过后端校验（未校验/失败均 false；获取验证码按钮据此 enable）
      password: '',
      showPwd: false,
      username: '',
      wechatId: '',
      shopLocation: '',
      source: '',
      sourceDetail: '',
      small: false,
      sectionText: '',
      sectionBtnText: '了解',
      btnShow: false,
      verifyingCode: false,
      registering: false,
      logoUrl: '',
      icpNumber: '',
      // 客服电话（canonical 配置）：「没有授权码」弹窗展示+可拨，未配置隐藏
      servicePhone: '',
      contactPhoneVisible: false,
      sourceOptions: [
        { value: 'referral', label: '老客户推荐' },
        { value: 'salesman', label: '业务员推广' },
        { value: 'store', label: '线下门店' },
        { value: 'other', label: '其他' }
      ]
    }
  },
  computed: {
    isPhoneValid () {
      return /^1[3-9]\d{9}$/.test(this.phone)
    },
    // 联通号段（过渡期提示用；运营商报备观察期结束后连同文案一起移除）
    isUnicomPhone () {
      return /^(130|131|132|145|146|155|156|166|175|176|185|186|196)\d{8}$/.test(this.phone)
    },
    isPasswordValid () {
      // 客户口径（体验优化一期）：8-20 位，须同时含字母和数字；不强制大小写/特殊字符（与后端 isCustomerPassword 同规则）
      return (val) => {
        if (!val || val.length < 8 || val.length > 20) return false
        return /[A-Za-z]/.test(val) && /\d/.test(val)
      }
    }
  },
  watch: {
    code (val) {
      // 授权码变化 → 重置校验态；防抖 400ms 后调后端校验（避免每键请求）
      this.authorizationCodeValidated = false
      clearTimeout(this._authCodeTimer)
      const c = (val || '').trim()
      if (c.length < 4) return
      this._authCodeTimer = setTimeout(() => { this.checkAuthorizationCode() }, 400)
    }
  },
  created () {
    // 品牌信息：Logo 首帧 bundle 默认，配置到位后替换
    fetchPublicConfig().then(cfg => {
      this.logoUrl = cfg.logoUrl
      this.icpNumber = cfg.icpRecordNumber
    })
    // 同一 publicConfig 缓存（零新增请求），单独取客服号
    fetchCustomerService().then(cs => { this.servicePhone = cs.phone })
    const token = localStorage.getItem('token')
    if (token) {
      this.$router.push('/home')
      return
    }
    // client_session_id：sessionStorage 持久（刷新不丢、关页即失效）；send/verify 必须一致
    let sid = sessionStorage.getItem('reg_client_session_id')
    if (!sid) {
      sid = this.genSessionId()
      sessionStorage.setItem('reg_client_session_id', sid)
    }
    this.clientSessionId = sid
  },
  beforeDestroy () {
    clearTimeout(this._authCodeTimer)
    if (this._smsTimer) clearInterval(this._smsTimer)
  },
  methods: {
    toLogin () {
      this.$router.push({ path: '/' })
    },
    toLoginHome () {
      if (this.btnShow) {
        this.$router.push({ path: '/' })
      }
    },
    genSessionId () {
      // 16 字节高熵（浏览器 crypto；send/verify 硬绑定字段之一）
      const arr = new Uint8Array(16)
      const c = window.crypto || window.msCrypto
      c.getRandomValues(arr)
      return Array.from(arr).map(b => b.toString(16).padStart(2, '0')).join('')
    },
    startCountdown (sec) {
      this.smsCountdown = sec || 60
      if (this._smsTimer) clearInterval(this._smsTimer)
      this._smsTimer = setInterval(() => {
        this.smsCountdown--
        if (this.smsCountdown <= 0) {
          clearInterval(this._smsTimer)
          this._smsTimer = null
        }
      }, 1000)
    },
    async checkAuthorizationCode () {
      // 防抖后调用：授权码只读校验（不消费）。失败保持 false，不弹提示（按钮 disable 自然反映）
      const c = (this.code || '').trim()
      if (c.length < 4) { this.authorizationCodeValidated = false; return }
      try {
        const res = await this.axios.post('auth/check-authorization-code', { code: c })
        this.authorizationCodeValidated = (res.data && res.data.code === 200)
      } catch (_) {
        this.authorizationCodeValidated = false
      }
    },
    async sendSmsCode () {
      if (!this.isPhoneValid) {
        this.small = true
        this.sectionText = '请输入正确的手机号'
        return
      }
      if (!this.authorizationCodeValidated) {
        this.small = true
        this.sectionText = '请先输入有效授权码'
        return
      }
      this.smsSending = true
      try {
        const res = await this.axios.post('auth/send-sms-code', {
          phone: this.phone,
          invite_code: this.code,
          client_session_id: this.clientSessionId
        })
        if (res.data.code === 200) {
          const d = res.data.data
          this.challengeId = d.challenge_id
          this.grantToken = ''            // 重新获取验证码 → 旧 grant 作废
          this.startCountdown(d.resend_after || 60)
          this.small = true
          if (d.dev_code) {
            this.smsCode = d.dev_code   // dev 联调自动填入（生产无此字段）
            this.sectionText = '【开发模式】验证码 ' + d.dev_code + ' 已自动填入'
          } else {
            this.sectionText = this.isUnicomPhone
              ? '验证码已发送。联通号码近期可能收不到短信（运营商报备中），若未收到请改用移动/电信号码注册'
              : '验证码已发送，请查收短信'
          }
        } else {
          this.small = true
          this.sectionText = res.data.message || '验证码发送失败'
        }
      } catch (err) {
        const r = err.response && err.response.data
        this.small = true
        // 授权码在 check 后被并发用尽/禁用 → reset 校验态，让用户重新输入
        if (err.response && err.response.status === 400 && r && /授权码/.test(r.message || '')) {
          this.authorizationCodeValidated = false
        }
        if (r && r.error === 'ACCOUNT_EXISTS') this.sectionText = '该手机号已注册，请直接登录'
        else if (r && r.error === 'REVIEW_PENDING') this.sectionText = '该手机号的注册申请正在审核中'
        else if (err.response && err.response.status === 429) this.sectionText = '操作过于频繁，请稍后再试'
        else if (err.response && err.response.status === 503) this.sectionText = '短信服务暂未配置，请联系管理员'
        else this.sectionText = (r && r.message) || '验证码发送失败'
      } finally {
        this.smsSending = false
      }
    },
    contactAdminTip () {
      // 联系电话从后台 system_config 读（customerService.phone），未配置时弹窗只有通用提示
      this.small = true
      this.contactPhoneVisible = true
      this.sectionText = '如需获取授权码，请联系管理员。'
    },
    async verifyCode () {
      if (!this.isPhoneValid) {
        this.small = true
        this.sectionText = '请输入正确的手机号'
        return
      }

      if (!this.authorizationCodeValidated) {
        this.small = true
        this.sectionText = '请先输入有效授权码'
        return
      }

      if (!this.smsCode || this.smsCode.trim().length < 4) {
        this.small = true
        this.sectionText = '请输入短信验证码'
        return
      }

      if (!this.challengeId) {
        this.small = true
        this.sectionText = '请先获取验证码'
        return
      }

      this.verifyingCode = true
      try {
        const res = await this.axios.post('auth/verify-sms-code', {
          challenge_id: this.challengeId,
          phone: this.phone,
          invite_code: this.code,
          code: this.smsCode,
          client_session_id: this.clientSessionId
        })

        if (res.data.code === 200) {
          this.grantToken = res.data.data.grant_token
          this.step = 2
        } else {
          this.small = true
          this.sectionText = res.data.message || '验证码错误'
        }
      } catch (err) {
        this.small = true
        this.sectionText = (err.response && err.response.data && err.response.data.message) || '验证失败，请重试'
      } finally {
        this.verifyingCode = false
      }
    },
    goBack () {
      this.step = 1
    },
    async signUp () {
      // 密码验证（客户口径：8-20 位，字母+数字）
      if (!this.password || this.password.length < 8 || this.password.length > 20) {
        this.small = true
        this.sectionText = '密码需为8-20位'
        return
      }

      if (!this.isPasswordValid(this.password)) {
        this.small = true
        this.sectionText = '密码需为8-20位，且同时包含字母和数字'
        return
      }

      // 用户名验证
      if (!this.username || this.username.trim().length === 0) {
        this.small = true
        this.sectionText = '请填写用户名'
        return
      }

      // 地址/档口验证
      if (!this.shopLocation || this.shopLocation.trim().length === 0) {
        this.small = true
        this.sectionText = '请填写地址/档口位置'
        return
      }

      // 来源验证
      if (!this.source) {
        this.small = true
        this.sectionText = '请选择您是如何了解到我们的'
        return
      }

      // grant_token 必须有效（verify-sms-code 签发；TTL 10min）
      if (!this.grantToken) {
        this.small = true
        this.sectionText = '验证已过期，请返回上一步重新获取验证码'
        return
      }

      this.registering = true
      try {
        const res = await this.axios({
          url: AP.apiList.register,
          method: 'post',
          data: {
            phone: this.phone,
            password: this.password,
            nickname: this.username || this.phone,
            wechat_id: this.wechatId,
            authorizationCode: this.code,
            grant_token: this.grantToken,
            source: this.source,
            sourceDetail: this.sourceDetail,
            shopLocation: this.shopLocation
          }
        })

        if (res.data.code === 200) {
          const d = res.data.data
          // 分支1：命中预备用户 → active + 签发 token，直接登录
          if (d && d.status === 'active' && d.token) {
            localStorage.setItem('token', d.token)
            if (d.user) {
              // key 必须用 'user'：全局 store 初始化 + 14 处读取都用 'user'，
              // 原 'userInfo' 是孤立写入无人读的 bug（注册后 token 在但 store.user 为空，故需刷新才进登录态）
              localStorage.setItem('user', JSON.stringify(d.user))
              // 同步 Vuex：与 loginpage.vue 登录成功路径一致，注册后立即生效不必刷新
              this.$store.commit('setUser', d.user)
            }
            this.$router.push('/home')
            return
          }
          // 分支2：未命中 → 进入人工审核
          this.small = true
          this.btnShow = true
          this.sectionBtnText = '去登录'
          this.sectionText = '注册成功！您的账号正在审核中，请等待管理员批准后再登录。'
        } else {
          this.small = true
          this.sectionText = res.data.message || '注册失败'
        }
      } catch (err) {
        const r = err.response && err.response.data
        this.small = true
        // 授权码在 check 后被并发用尽/禁用 → reset 校验态，让用户重新输入
        if (err.response && err.response.status === 400 && r && /授权码/.test(r.message || '')) {
          this.authorizationCodeValidated = false
        }
        if (r && r.error === 'ACCOUNT_EXISTS') this.sectionText = '该手机号已注册，请直接登录'
        else if (r && r.error === 'REVIEW_PENDING') this.sectionText = '该手机号的注册申请正在审核中'
        else if (r && r.message && r.message.includes('UNIQUE')) this.sectionText = '该手机号已被注册'
        else this.sectionText = (r && r.message) || '注册失败，请稍后重试'
      } finally {
        this.registering = false
      }
    }
  }
}
